import {createReducer, on} from '@ngrx/store';
import * as Actions from '../actions/user.actions';

export interface State {
    isPending: boolean;
}

export const initialState: State = {
    isPending: false
};

export const reducer = createReducer(
    initialState,

    on(Actions.registration, state => ({...state, isPending: true})),
    on(Actions.registrationSuccess, state => ({...state, isPending: false})),
    on(Actions.registrationFailure, state => ({...state, isPending: false}))
);

export const getIsPending = (state: State) => state.isPending;
